import { BUILD_ID, PRODUCT_VERSION, versionLabel } from '../../constants/appVersion';
import { isBeta, parseVersion } from '../../utils/releaseVersion';

/**
 * ⭐ "BETA v0.7.0.0.0" under the wordmark (owner, 2026-10-04) — the build id on hover so a
 * screenshot in feedback still names the exact deploy.
 *
 * ⚠️⚠️ MUST NOT GROW THE HEADER. It is laid out BELOW the logo, out of flow
 * (`absolute top-full`), inside the header's own bottom padding — so the logo keeps
 * its place in the row and the row keeps its height. Measured against the built CSS
 * (header 65px at 1280×800 with and without it).
 * ⚠️ `left-[17px]` lines it up with the "M": the wordmark PNGs carry 16.9px (dark)
 * / 16.5px (light) of transparent padding at the 28px height `Logo` renders.
 * ⭐ BETA shows while Main is 0 (`isBeta`); from 1.x.x.x.x it is just the version.
 *   A version that does not parse keeps BETA — never claim a launch by accident.
 */
export function BetaBadge({ version = PRODUCT_VERSION, build = BUILD_ID }: { version?: string; build?: string }) {
  const label = versionLabel(version);
  const parsed = parseVersion(version);
  const beta = parsed ? isBeta(parsed) : true;
  return (
    <span
      data-testid="beta-badge"
      title={build ? `Build ${build}` : undefined}
      className="absolute left-[17px] top-full flex items-center gap-1 whitespace-nowrap text-[10px] leading-none select-none"
    >
      {/* ⚠️ The PILL keeps its size (45×14, measured live) and only the word shrinks
          (owner, 2026-10-04): fixed box, centred text. `pl-[0.12em]` balances the
          trailing letter-spacing so the word sits optically centred. */}
      {beta && (
        <span className="inline-flex h-[14px] w-[45px] items-center justify-center rounded-full border border-primary/40 bg-primary/10 pl-[0.12em] text-[8px] font-semibold uppercase tracking-[0.12em] text-primary">
          Beta
        </span>
      )}
      {label && <span className="font-medium tabular-nums text-muted-foreground">{label}</span>}
    </span>
  );
}
